
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.302 30.257c1.266 2.194-.323 4.937-2.852 4.937H3.54c-2.532 0-4.114-2.747-2.85-4.937l16.455-28.53c1.266-2.196 4.438-2.192 5.702 0l16.455 28.53zm-19.306-5.899a3.155 3.155 0 100 6.31 3.155 3.155 0 000-6.31zM17 13.02l.508 9.327a.823.823 0 00.822.778h3.33a.823.823 0 00.821-.778l.509-9.327a.823.823 0 00-.822-.867h-4.347a.823.823 0 00-.821.867z","fill":"#fff","fill-opacity":".38"}})])
          )
        }
      }
    